/**
 * Customization Quick-Add Handler
 * Handles "Customise" button clicks on product cards, including dynamically loaded content
 */

(function() {
  'use strict';

  /**
   * Handle click events on customise buttons
   * Uses event delegation to work with dynamically loaded content
   */
  function handleCustomiseButtonClick(e) {
    const customiseButton = e.target.closest('.quick-add__button--customise');
    if (customiseButton) {
      e.preventDefault();
      const productUrl = customiseButton.getAttribute('data-product-url');
      if (productUrl) {
        window.location.href = productUrl;
      }
    }
  }

  // Attach event listener using delegation on document
  // This works for both initial page load and AJAX-loaded content
  document.addEventListener('click', handleCustomiseButtonClick);
})();
